import React, {useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Week00 from '../../assets/images/weekly-maternity-tracker/WK-00.png';
import Week01 from '../../assets/images/weekly-maternity-tracker/WK-01.png';
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from "react-i18next";
import axios from "axios";
import ErrorModal from "../Security/ErrorModal";

const WeeklyPregnancyTracker = () => {
    const userInfo = useSelector((state) => state.userData);
    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";
    const token = localStorage.getItem('AccessToken');
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [currentWeek, setCurrentWeek] = useState("");
    const [info, setInfo] = useState("");
    const [trackerData, setTrackerData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [selectedWeek, setSelectedWeek] = useState("");  // Default selected week
    const [centerWeek, setCenterWeek] = useState(selectedWeek || 3); // Default to selectedWeek or 7
const [startWeek, setStartWeek] = useState(
  selectedWeek ? Math.max(selectedWeek - 3, 3) : 3
); // Ensure startWeek is valid
const [showModal, setShowModal] = useState(false);
const [modalMessage, setModalMessage] = useState("");

    // Fetch tracker details
    const fetchTrackerDetails = async (week) => {
      setIsLoading(true);
      try {
        const params = {
          SelectedWeek: week,  // Send the selected week
          DeviceType: isHighmarkPortal ? "HighmarkPortal" : "PatientPortal",
          EmailID: userInfo.userData.EmailID,
          MemberID: userInfo.userData.MemberID,
          Contract: userInfo.userData.ContractIdentified,
        };
  
        const response = await axios.post(
          Endpoints.LoadPregnancyTrackerDetails,
          { _Params: JSON.stringify(params) },
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
              "Accept": "*/*",
              Authorization: `Bearer ${token}`,
            },
          }
        );
  
        if (response.data.Result === 1) {
          console.log("res",response.data);
          setTrackerData(response.data);
          // If selectedWeek is empty, set it to the `CurrentWeek` from the response
        if (!week) {
          setSelectedWeek(response.data.WeekNo || 3); // Fallback to 1 if `CurrentWeek` is unavailable
        }
      } else if (response.data.Result === 0 && response.data.ResultText) {
        // Specific handling for Result 0
        //setTrackerData(null); // Clear existing tracker data
        setModalMessage(response.data.ResultText);
        setShowModal(true);
  
        
      }
      } catch (err) {
        setError("An error occurred while fetching the data.");
      } finally {
        setIsLoading(false);
      }
    };
  
    useEffect(() => {
      fetchTrackerDetails(selectedWeek);  // Fetch details for the default week
      // Update centerWeek and startWeek based on the selectedWeek
  if (selectedWeek) {
    setCenterWeek(selectedWeek);
    setStartWeek(Math.max(selectedWeek - 3, 1)); // Ensure startWeek doesn't go below 1
  }
    }, [selectedWeek]);
  
    const handleWeekSelection = (week) => {
      setSelectedWeek(week);  // Update selected week
    };
  const handleBackClick=()=>
  {
    navigate('/home')
  }

  
  const weeks = Array.from({ length: 40 }, (_, index) => index + 3); // Generate weeks 1 to 42
  const getCenterWeek = (start) => {
    // The center week is the middle of the current visible range
    return start + 3;  // Middle element of the range (3 is the 4th index in a 7-week range)
  };

  const handlePrev = () => {
    if (startWeek >= 3) {
      const newStartWeek = startWeek - 1;
      setStartWeek(newStartWeek);
      //setCenterWeek(getCenterWeek(newStartWeek));
      //setSelectedWeek(getCenterWeek(newStartWeek));
    }
  };

  const handleNext = () => {
    if (startWeek + 1 < weeks.length) {
      let newStartWeek;
      newStartWeek = startWeek + 1;
      // if (selectedWeek === 3) {
      //   newStartWeek = 1; // Reset to 1 when selectedWeek is 3
      // } else {
      //  newStartWeek = startWeek + 1;  // Normal increment
      // }
      setStartWeek(newStartWeek);
      //setCenterWeek(getCenterWeek(newStartWeek)); // Set clicked week as center
      //setSelectedWeek(getCenterWeek(newStartWeek));
    }
  };

  const handleWeekClick = (week) => {
    setCenterWeek(week); // Set clicked week as center
    setSelectedWeek(week); // Update selected week
  };


  const handleNavigation = (value) => {
    // Navigate to the specified path and pass the selected week in location state
    navigate('/baby-devlopment', { state: {value:value, week: selectedWeek } });
  };
  const handleImageClick = () => {
      navigate("/recipe-card", { state: { selectedWeek: selectedWeek } });
  };

  const getMonthName = (dateString) => {
    if (!dateString) return ""; // Handle undefined or null date
    const date = new Date(dateString);
    return date.toLocaleString("default", { month: "long" }); // Extract full month name
  };

  const getDayNumber = (dateString) => {
    if (!dateString) return ""; // Handle undefined or null date
    const date = new Date(dateString);
    return date.getDate(); // Extract the day number
  };
  const getYear = (dateString) => {
    if (!dateString) return ""; // Handle undefined or null date
    const date = new Date(dateString);
    return date.getFullYear(); // Extract the year
  };

  const handleModalClose = () => {
    setShowModal(false);
    navigate('/home')
  };
   if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>        
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>
    <div className="col-md-12 col-lg-6 mt-4 d-flex inner-page-heading-wrapper">
      <button className="win-back-btn me-1" onClick={handleBackClick}>
        <span>
          <i className="bi bi-chevron-left"></i> {t("back")}
        </span>
      </button>
      <h2 className="page-heading">{t('weekly_pregnancy_tracker')}</h2>
    </div>

    <div className="col-md-12 col-lg-6 mt-5 d-flex justify-content-end align-items-center weekly-pregnancy-tracker-buttons">
      <button className="win-btn-with-icon baby-btn" onClick={() => handleNavigation("Baby")}>{(t('baby'))}</button>
      <button className="win-btn-with-icon mom-btn ms-3" onClick={() => handleNavigation("Body")}>{(t('mom'))}</button>
      <button className="win-btn-with-icon nutrition-btn ms-3" onClick={() => handleNavigation("Nutrition")}>{(t('nutrition'))}</button>
      <button className="win-btn-with-icon whats-next-btn ms-3" onClick={() => handleNavigation("Tests")}>{(t('whatnext'))}</button>
    </div>

    <div className="row mb-5">
      <div className="col-md-12 col-lg-6 mt-4 d-flex justify-content-center flex-sm-column flex-column">
        <div className="weekly-tracker-ref-image-wrapper"
        onClick={handleImageClick}
        style={{ cursor: "pointer" }}>
          <img
            src={trackerData?.HeroFruitImagePath }
            className="weekly-tracker-ref-image"
            alt={`Week ${selectedWeek} image`}
          />
        </div>
        <p className="weekly-tracker-ref-text">
          At {selectedWeek} weeks,{" "}
          {/* <span>your baby is about the size of a {trackerData?.HeroFruit}.</span> */}
          <span>{trackerData?.HeroFruitDescription}</span>
        </p>
      </div>

      <div className="col-md-12 col-lg-6 mt-4 d-flex justify-content-center flex-sm-column flex-column align-items-center">
        <div className="week-indicators-main">
          <div className="week-indicators-heading-wrapper">
            <h4 className="week-indicators-heading">{t('week_heading')}</h4>
          </div>
          
          <div className="week-indicators-wrapper">
            <button className="week-slider-next-previous-btns" onClick={handlePrev} ><i class="bi bi-chevron-left"></i></button>
            {/* Dynamically map weeks */}
            <div className="week-scroller">
              {weeks.slice(Math.max(startWeek - 2, 0), Math.min(startWeek + 3, weeks.length)).map((week) => (
                <div
                  key={week}
                  className={`week-indicator ${week.toString() === centerWeek.toString() ? 'current-week' : 'previous-1-week'}`}
                  onClick={() => handleWeekClick(week)}
                >
                  {week}
                </div>
              ))}
              </div>
            <button className="week-slider-next-previous-btns" onClick={handleNext}><i class="bi bi-chevron-right"></i></button>
          </div>
          <div className="week-indicators-heading-wrapper">
            <h4 className="week-indicators-heading">
              {trackerData?.Trimester} TRIMESTER
            </h4>
          </div>
        </div>

        <div className="progress-stats-main">
          <div className="progress-stats-wrapper">
            <div className="progress-stat-top-label">{t('gestational_age')}</div>
            <div className="progress-stat-center-label">
              {trackerData?.GestAgeInDays / 7}
            </div>
            <div className="progress-stat-bottom-label">
              weeks
              <br />
              {trackerData?.GestAgeInDays} days
            </div>
          </div>

          <div className="progress-stats-wrapper">
            <div className="progress-stat-top-label">DUE DATE</div>
            <div className="progress-stat-center-label text-primary-color">
            {getDayNumber(trackerData?.DueDate)}
            </div>
            <div className="progress-stat-bottom-label"> {getMonthName(trackerData?.DueDate)}
            <br />
            {getYear(trackerData?.DueDate)}
            </div>
          </div>

          <div className="progress-stats-wrapper">
            <div className="progress-stat-top-label">REMAINING</div>
            <div className="progress-stat-center-label">
              {trackerData?.RemainingInWeeks}
            </div>
            <div className="progress-stat-bottom-label">
              weeks
              <br />
              {trackerData?.RemainingInDays} days
            </div>
          </div>
        </div>
      </div>
    </div>
    <ErrorModal show={showModal} message={modalMessage} onClose={handleModalClose} closeButton={true} />
  </>
);
};

export default WeeklyPregnancyTracker;
